import { gql } from "@apollo/client";

const DELETE_EVALUACION_PROFESIONAL = gql`
    mutation deleteEvaluacionProfesional($idEvaluacionProfesional: Int!){
        deleteEvaluacionProfesional(idEvaluacionProfesional: $idEvaluacionProfesional) {
            success
            valorEsperado
        }
    }
`;

export default DELETE_EVALUACION_PROFESIONAL;